import React from 'react';

/**
 * Mobile-first frame for the sign-up steps: one ask per screen.
 *
 * Mobile first — the column is capped at 440px on a phone and 600px from
 * tablet up (App.scss, .signup-shell), always a single column. Type sizes
 * are the floor for a phone held at arm's length: title 28–32px, lead 16px,
 * nothing smaller than 16px in the body. Inputs and buttons that live inside
 * use the `signupControl` / `signupPrimary` styles below (52px tall, 16px
 * text so iOS doesn't zoom on focus).
 *
 * step/of: the "Step 2 of 3" line above the title. Omit on single-screen uses.
 * dark: the login surface is black; the profile and payout screens are white.
 */
export const SIGNUP_MAX_WIDTH = 440;

export const signupControl = {
  height: 52,
  fontSize: 16,
  borderRadius: 8,
};

export const signupPrimary = {
  width: '100%',
  height: 52,
  fontSize: 18,
  fontWeight: 600,
  borderRadius: 8,
  border: 'none',
  background: '#ff0098',
  color: '#fff',
  cursor: 'pointer',
};

export const signupTextLink = {
  background: 'none',
  border: 'none',
  padding: '12px 0',
  minHeight: 44,
  fontSize: 16,
  cursor: 'pointer',
  width: '100%',
};

export default function SignupShell({
  step, of, title, lead, children, footer, dark = false,
}) {
  const fg = dark ? '#fff' : '#111';
  const muted = dark ? 'rgba(255,255,255,0.6)' : '#595959';
  return (
    <div
      className="signup-shell"
      style={{
        width: '100%',
        margin: '0 auto',
        padding: '8px 16px 32px',
        boxSizing: 'border-box',
      }}
    >
      {step && of ? (
        <div
          style={{
            fontSize: 14, fontWeight: 600, letterSpacing: '0.06em',
            textTransform: 'uppercase', color: muted, marginBottom: 8,
          }}
        >
          {`Step ${step} of ${of}`}
        </div>
      ) : null}
      {title ? (
        <h1
          style={{
            fontSize: 'clamp(28px, 7vw, 32px)', fontWeight: 800, lineHeight: 1.15,
            letterSpacing: '-0.02em', color: fg, margin: '0 0 8px',
          }}
        >
          {title}
        </h1>
      ) : null}
      {lead ? (
        <p style={{ fontSize: 16, lineHeight: 1.45, color: muted, margin: '0 0 20px' }}>
          {lead}
        </p>
      ) : null}
      {children}
      {footer ? <div style={{ marginTop: 20 }}>{footer}</div> : null}
    </div>
  );
}
